import { create } from 'zustand';
import { IHabitTrackerCalendarYear } from '../habit-tracker-interfaces';

interface HabitTrackerState {

    year: number;
    setYear: (_year: number) => void;

    calendarData: IHabitTrackerCalendarYear|null;
    setCalendarData: (_calendarData: IHabitTrackerCalendarYear|null) => void;
}

export const useHabitTrackerStore = create<HabitTrackerState>()((set) => ({

    year: (new Date()).getFullYear(),
    setYear: (_year: number) => {
        return set((state: HabitTrackerState) => {
            return {
                ...state,
                year: _year,
            };
        });
    },

    calendarData: null,
    setCalendarData: (_calendarData: IHabitTrackerCalendarYear|null) => {
        return set((state: HabitTrackerState) => {
            return {
                ...state,
                calendarData: _calendarData,
            };
        });
    },
}))